var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 204,
    viewBox: "0 0 204 204",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "matrix(4 0 0 4 -1008 -172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "translate(252 43)",
    fill: "#FFE79C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "user image"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "translate(265.23 54.1924)",
    fill: "#FCCAA0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "translate(281.064 65.7701)",
    fill: "#350304"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 3.1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "translate(268.87 65.5881)",
    fill: "#350304"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path3_fill",
    transform: "translate(273.909 74.2328)",
    fill: "#5C2C04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path4_fill",
    transform: "translate(274.967 74.2328)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path5_fill",
    transform: "translate(280.547 60.9839)",
    fill: "#855837"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path6_fill",
    transform: "translate(276.423 70.6839)",
    fill: "#EAA16A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path7_fill",
    transform: "translate(275.649 76.8716)",
    fill: "#E98764"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path8_fill",
    transform: "translate(269.512 86.358)",
    fill: "#E27A5D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path9_fill",
    transform: "translate(260.367 48.8385)",
    fill: "#623619"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path10_fill",
    transform: "translate(274.148 73.4138)",
    fill: "#E27C63"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M 51 25.5C 51 39.5833 39.5833 51 25.5 51C 11.4167 51 0 39.5833 0 25.5C 0 11.4167 11.4167 0 25.5 0C 39.5833 0 51 11.4167 51 25.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    d: "M 22.567 7.39188C 22.567 8.11985 23.7803 14.6716 24.387 17.8564C 24.056 19.8918 22.6627 25.5001 20.8655 30.3229C 22.3214 34.1902 23.9139 37.0566 23.9139 37.0566C 23.9139 37.0566 19.8191 39.559 12.7214 39.7637C 6.05193 39.7637 0.846374 37.5798 0.277648 36.7836L 3.00287 30.3229L 2.45689 25.9551L 2.00191 18.9484L 0 8.66583L 6.18773 2.11411C 9.9489 1.32548 17.7442 -0.19719 18.8362 0.021201C 20.2011 0.294189 22.567 6.48192 22.567 7.39188Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    d: "M 2.91187 0C 0.800766 0 0.0909961 2.12324 0 3.18486C 0.28028 2.45689 1.29144 1.00096 3.09387 1.00096C 4.89629 1.00096 5.72546 2.15357 5.91475 2.72988C 5.79342 1.81992 5.02298 0 2.91187 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3_fill",
    d: "M 8.42851 0C 8.24652 0.674799 5.16403 4.74744 3.98108 4.26544C 2.76666 4.69429 0.422164 0.858054 0 0L 8.42851 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4_fill",
    d: "M 1.36494 1.09195C 0.491379 1.09195 0.0909961 0.363984 0 0L 6.00574 0C 5.97541 0.363984 5.71455 1.09195 4.91379 1.09195L 1.36494 1.09195Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5_fill",
    d: "M 4.42958 1.05537C 2.79165 0.327402 0.243758 0.691386 0.152762 0.691386C 0.061766 0.691386 -0.0838277 0.673187 0.061766 0.60039C 2.32674 -0.486796 3.05825 0.049677 4.41174 1.04229L 4.42958 1.05537Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6_fill",
    d: "M 3.27586 0L 0 0C 0.272988 0.818965 0.741638 1.19042 1.27395 1.26904C 1.80625 1.34766 1.63224 1.35357 2.11566 1.26904C 2.59908 1.18451 3.08249 0.801903 3.27586 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7_fill",
    d: "M 2.30903 1.00096C 1.09878 1.00096 0.265405 0.333652 0 0C 0.204741 0.341235 1.27395 1.7858 2.4114 1.7858C 3.32136 1.7858 4.27682 0.671096 4.6408 0.113745C 4.36781 0.409482 3.51927 1.00096 2.30903 1.00096Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8_fill",
    d: "M 3.81716 3.34411L 3.98778 0C 3.56313 0.242656 2.3362 0.81214 1.09865 1.46731C 1.18965 3.19624 0.636973 3.61709 0 6.34697C 8.23515 9.30435 16.948 6.30148 16.675 6.02849C 16.4566 5.8101 16.4239 3.04079 16.1813 1.97916L 13.4172 0.443606L 13.2808 2.88913C 11.8248 4.70905 6.36505 3.95075 3.81716 3.34411Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9_fill",
    d: "M 9.14031 3.10019C -0.778247 9.92489 -0.0502939 14.7477 3.86253 30.308C -3.69016 33.4929 1.86062 36.8597 3.58955 37.5877C 1.04166 40.3176 5.40947 41.9555 6.59242 41.0456C 7.53878 40.3176 12.3252 37.9517 14.6001 36.8597L 14.8731 31.309C 11.3788 30.8722 7.77537 25.0302 7.77537 23.7563C 7.77537 22.1487 7.81177 18.6241 7.95736 17.3866C 8.67176 17.2973 13.768 14.5789 15.2477 13.7896L 15.328 13.7467C 15.1097 14.5475 14.7517 15.5363 14.6001 15.9306C 18.0215 14.1107 22.0921 9.89456 23.6997 8.01398C 25.0646 14.0197 24.9736 15.9306 27.9765 23.9383C 25.7198 28.4517 22.0618 31.036 20.5148 31.8549L 20.6968 37.1327C 23.8817 38.6797 24.6096 39.0436 27.6125 41.3185C 34.8922 40.0446 35.5292 37.0417 32.1623 35.9498C 36.6757 33.2563 32.8903 31.5516 30.4334 31.036C 31.0097 25.4246 33.0997 19.2065 33.0997 12.5092C 33.0997 8.01398 30.7974 3.55517 24.2457 0.825286C 19.0043 -1.35862 11.8702 1.28027 9.14031 3.10019Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10_fill",
    d: "M 7.82566 0.818965L 0 0.818965C 2.47509 0.0909961 2.09291 -2.38646e-07 4.00383 0C 5.91475 1.58849e-06 7.68007 0.818965 7.82566 0.818965Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b3f69d97fcd7ba04eb674bbe575ac857.svg";
export { ForwardRef as ReactComponent };